/** `'YYYY-MM-DD'`. El contrato no exporta un tipo para esto, así que se nombra aquí. */
type FechaLocal = string;

/**
 * `Date` -> `'YYYY-MM-DD'` en hora LOCAL.
 *
 * `toISOString()` NO sirve aqui: convierte a UTC, asi que un 1 de marzo seleccionado en Madrid se
 * manda como 28 de febrero. Con un filtro de fechas que decide que se paga, eso es un dia entero de
 * viajes dentro o fuera de la seleccion.
 */
export function aFechaLocal(d: Date): FechaLocal {
  const anio = d.getFullYear();
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');
  return `${anio}-${mes}-${dia}`;
}

/** `'YYYY-MM-DD'` -> `Date` local, para devolver el valor al date picker sin desfase. */
export function deFechaLocal(f: FechaLocal): Date {
  const [anio, mes, dia] = f.split('-').map(Number);
  return new Date(anio!, mes! - 1, dia!);
}

const EUR = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });

/**
 * Formatea un importe del contrato (string decimal) para pintarlo.
 *
 * El `Number()` es SOLO para presentacion: los importes viajan como string precisamente para no
 * pasar por un float, y aqui no se suma ni se compara nada, solo se formatea lo que ya calculo el
 * backend.
 */
export function formatearEur(importe: string): string {
  return EUR.format(Number(importe));
}

const NUM = new Intl.NumberFormat('es-ES');

export function formatearNumero(n: number): string {
  return NUM.format(n);
}
